import Vue from 'vue'
import * as AgGridEnterprise from 'ag-grid-enterprise'

import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-balham.css'

AgGridEnterprise.LicenseManager.setLicenseKey('Parker_Technology_Services,_LLC_KP_Dashboard_1Devs_1Deployment_8_July_2020__MTU5NDE2MjgwMDAwMA==23836b505ea64c36d0bc08755b365779')
